import React from 'react';
import './styles.css';

export default function(props){
	let {current=0, percent=false, symbol, barProps={}, textProps={}, ...other} = props;
	var left = (!percent?(current+'0'):percent);
	return(
		<div className='progress-line' {...other}>
		  <div {...barProps}>
		    <div style={{left:left+'%'}}></div>
		  </div>
		  <span 
		  	{...textProps}
		  	style={{
		  		color:left<=32?'#7AF400':left>=62?'#FE3D2C':'#F8E239',
		  		...textProps.style
		  	}}
		  >
		  	{current+(symbol?'%':'')}
		  </span>
		</div>
	)
}